import InfoIcon from '@mui/icons-material/Info';
import { IconButton, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';

const ChartTooltip = ({ infoText, styleMarginTop = 46 }) =>
  infoText ? (
    <Tooltip title={infoText || ''} placement="top">
      <IconButton
        sx={{ position: 'absolute', top: styleMarginTop, right: 0 }}
        size="small"
        aria-label="Información sobre el gráfico"
      >
        <InfoIcon />
      </IconButton>
    </Tooltip>
  ) : null;

ChartTooltip.propTypes = {
  infoText: PropTypes.string,
  styleMarginTop: PropTypes.number,
};

export default ChartTooltip;
